var _ellipse, _ellipse2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.9156,
    cy: 50,
    rx: 35.9391,
    ry: 36,
    fill: "#D0FFF3"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.9156,
    cy: 50,
    rx: 24.9577,
    ry: 25,
    fill: "#189877"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.331 50C99.331 77.3389 77.2061 99.5 49.9155 99.5C22.6249 99.5 0.5 77.3389 0.5 50C0.5 22.6611 22.6249 0.5 49.9155 0.5C77.2061 0.5 99.331 22.6611 99.331 50Z",
    stroke: "#189877"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6982 42.2266L46.0273 57.7867C45.8896 57.9233 45.7028 58 45.5082 58C45.3135 58 45.1268 57.9233 44.9891 57.7867L38.1331 50.9792C38.0033 50.8409 37.9327 50.658 37.936 50.4691C37.9394 50.2801 38.0165 50.0998 38.1511 49.9662C38.2857 49.8325 38.4672 49.756 38.6575 49.7527C38.8478 49.7493 39.032 49.8195 39.1713 49.9483L45.5082 56.2392L60.66 41.1958C60.7992 41.0669 60.9834 40.9968 61.1737 41.0001C61.364 41.0034 61.5456 41.08 61.6802 41.2136C61.8148 41.3473 61.8919 41.5276 61.8952 41.7165C61.8986 41.9055 61.8279 42.0883 61.6982 42.2266Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.4a4f9617fddc34d1e7d1c56d584ae1b1.svg";
export { ForwardRef as ReactComponent };